import useSetExport from '@components/export/useSetExport';
import { cloneDeep } from 'lodash';
import { usageMetricList } from '../atoms';
import {
  useFetchAPIUsageMetric,
  useFetchAppUsageMetric,
  useFetchVideoUsageMetric,
} from './dataFetcherhooks';
import { buildSeriesData, getUsageMetricsMeta } from './utils';

const metricSeriesApisByProduct = {
  EI: (object) => useFetchVideoUsageMetric(object),
  APP: (object) => useFetchAppUsageMetric(object),
  API: (object) => useFetchAPIUsageMetric(object),
};

export function useGetDataForMetric(metric) {
  const product = usageMetricList[metric].product;
  return metricSeriesApisByProduct[product]({ enabled: false, product, metric });
}

export function useMetricSeries({ metric, instance }: any) {
  const { data }: any = useGetDataForMetric(metric);
  const { data: chartData } = data;

  if (instance) {
    buildSeriesData({
      instance,
      data: chartData,
      allMetrics: cloneDeep(getUsageMetricsMeta()),
      metric,
    });
  }
  return chartData;
}

export function useMakeExportData({ seriesData = { data: [], totals: {} }, sectionKey, title }) {
  const timestampMap = {};
  let data: any = [];
  const header = ['Timestamp'];
  const footer = ['Total'];

  const timeseriesData = { ...seriesData.data };
  const totals = { ...seriesData.totals };

  // make empty hashmap like:-  { timestamp: [] }
  Object.keys(timeseriesData).forEach((metric) => {
    timeseriesData[metric].map((series) => {
      timestampMap[series[0]] = [];
    });
  });

  // make export data for every metric (put value into hashmap)
  Object.keys(timeseriesData).forEach((metric) => {
    header.push(usageMetricList[metric].displayName);
    timeseriesData[metric].map((series) => {
      timestampMap[series[0]].push(series[1]);
    });
    footer.push(totals[metric]);
  });

  Object.keys(timestampMap).forEach((timestamp) => {
    data.push([timestamp, ...timestampMap[timestamp]]);
  });
  data = [header, ...data, footer];

  useSetExport({
    pageKey: 'usageDashboard',
    sectionKey,
    widgetKey: 'metric',
    widgetInfo: { title },
    data,
    headers: [],
  });
}
